<div class="mawb-subscription">
    <h2 class="mat-headline-6 mb-0 fw-700">MAWB subscription</h2>
    <form [formGroup]="mawbSubscriptionForm">
        <mat-checkbox class="mat-small mb-3" formControlName="isSelected" (change)="activeSubscription($event.checked)">
            I want to receive alerts regarding the MAWB identified above.
        </mat-checkbox>
        @if (showEmail) {
            <mat-form-field class="col-12">
                <mat-label for="email" class="label-lg text-nowrap"> Subscription email </mat-label>
                <input
                    matInput
                    type="email"
                    formControlName="email"
                    placeholder="user@gmail.com"
                    (keyup)="onKeyEmail()"
                />
                <mat-error>
                    <app-field-error [field]="'email'" [messageList]="formErrors['email']" />
                </mat-error>
            </mat-form-field>
        }
    </form>
</div>
